import { DOM } from '../../common/browser';
import '../../common/common.js';
import { constants } from '../../common/common.js';

DOM.ready(() => {
    //Initialize page components
    hideMenuMainHeader();
    setCurrentPage();
});

const rafurlExtid = window.location.search.indexOf('extid') > 0 ? window.location.search.match(/extid=([^&]*)/i)[1] : '';
if(document.querySelector('#chkOffer')) {
    document.querySelector('#chkOffer').addEventListener('click', () => {
        window.location.href = window.location.href.replace('/about', '');
    });
}

if(document.querySelector('#linkCard')) {
    document.querySelector('#linkCard').addEventListener('click', () => {
        if (window.location.href.indexOf('/about?') > 0) {
            window.location.href = window.location.href.replace('/about?', '?action=linkcard&');
        } else {
            window.location.href = window.location.href.replace('/about', '?action=linkcard');
        }
    });
}
const chkOldTemplate = document.querySelector('.charity-section-button.oldTemplate');
if (!chkOldTemplate) {
    const signInButton = document.querySelector('.inner-container__buttons-signin');
    const registerButton = document.querySelector('.inner-container__buttons-register');
    if (signInButton) {
        signInButton.addEventListener('click', () => {
            let url = constants.signInFromAboutLinkPart1 + encodeURIComponent(window.location.origin + constants.signInFromAboutLinkPart2);
            const chkSignExtId = rafurlExtid ? '&extid=' + rafurlExtid : '';
            url = url + chkSignExtId;
            window.location.replace(url);
        });
    }

    if (registerButton) {
        registerButton.addEventListener('click', () => {
            let url = constants.registerFromAboutLink;
            const chkRegExtId = rafurlExtid ? '&extid=' + rafurlExtid : '';
            url = url + chkRegExtId;
            window.location.replace(url);
        });
    }
}

const thumbnailCard = document.querySelectorAll('.sparks-thumbnails__subcard');
if (thumbnailCard) {
    for (let a = 0; a < thumbnailCard.length; a++) {
        thumbnailCard[a].addEventListener('click', () => {
            const targetValue = thumbnailCard[a].getAttribute('data-target');
            if (targetValue) {
                window.location.href = targetValue;
            }
        });
    }
}

if (document.querySelector('#chkCharity')) {
    document.querySelector('#chkCharity').addEventListener('click', () => {
        window.location.replace('./mycharity');
    });
}

function hideMenuMainHeader() {
    if (document.getElementById('mainHeader')) {
        document.getElementById('mainHeader').style.display = 'none';
    }
}
function setCurrentPage() {
    const accordion = document.querySelectorAll('.accordion__section__content-sublink');
    for (let i = 0; i < accordion.length; i++) {
        if (accordion[i].id === 'aboutSparks') {
            accordion[i].classList.add('highlight');
            document.getElementById('mainHeader').style.display = 'none';
        }
    }
}

if (window.location.href.includes('/ie')) {
    if (document.querySelector('.charity-section-charity1')) {
        document.querySelector('.charity-section-charity1').classList.add('charity1_roi');
    }
    if (document.querySelector('.charity-section-charity2')) {
        document.querySelector('.charity-section-charity2').classList.add('charity2_roi');
    }
    if (document.querySelector('.charity-section-charity3')) {
        document.querySelector('.charity-section-charity3').classList.add('charity3_roi');
    }
    if (document.querySelector('.offers__sampleFlower')) {
        document.querySelector('.offers__sampleFlower').classList.add('offers__roi1');
    }
    if (document.querySelector('.offers__sampleTea')) {
        document.querySelector('.offers__sampleTea').classList.add('offers__roi2');
    }
}

